var screenWidth = {
    check: function(){
        return window.innerWidth;
    },
    mobile: function(){
        if(window.innerWidth <= 991){
            return true;
        }
    }
}